// function to convert a list of keys from strings
// to floats, the api is sending them in as strings
// because they are Ruby BigDecimal on the api
export const convertStringToNumber = <T extends Object>(
  keysToConvert: Array<keyof T>,
  item: T,
) => {
  for (const k of keysToConvert) {
    const tmp = item[k];
    item[k] = Number(tmp) as any;
  }

  return item;
};
